import { Entity } from './commom/entity'

export class Professional extends Entity {
  slug = ''
}
